import { type ApplicationSteps, type PartialRecord } from 'share/types'
import { pathnames } from 'utils/constants'

export const getConfirmationThirdPartyPledgePaths = (key: ApplicationSteps) => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    AWAITING_THIRD_PARTY_PLEDGE_CONFIRMATION: pathnames.decision,
    FETCH_THIRD_PARTY_PLEDGER_PERSONAL_INFO: pathnames.decision,
    GENERATE_THIRD_PARTY_PLEDGER_DOCUMENTS_SIGNED_BY_OTP: pathnames.decision,
    THIRD_PARTY_PLEDGER_PRE_SCORE: pathnames.decision,
    THIRD_PARTY_PLEDGER_BIOMETRY_FORENSICS: pathnames.decision,
    THIRD_PARTY_PLEDGER_SCORING: pathnames.decision,
    FETCH_THIRD_PARTY_PLEDGER_PKB_REPORT: pathnames.decision,
    THIRD_PARTY_PROPERTY_PLEDGES: pathnames.decision,
    AWAITING_THIRD_PARTY_PROPERTY_CHOICE: pathnames.decision,
    DECISION: pathnames.decision
  }

  return paths[key]
}

export const getThirdPartyPledgePaths = (key: ApplicationSteps) => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    DECISION: pathnames.decision,

    UPDATE_LOAN_DATA_IN_TELEMARKETING: pathnames['internal-step-loader'],

    AWAITING_THIRD_PARTY_CONDITIONS_CONFIRMATION: pathnames['internal-step-loader'],
    FETCH_DDOCS: pathnames['digital-doc'],
    CHECK_TAX_DEBT: pathnames['own-debt'],
    FETCH_THIRD_PARTY_PLEDGER_DDOCS: pathnames['internal-step-loader'],
    CHECKING_COLLATERAL: pathnames['open-borrower-account'],
    CREATE_ESTIMATION: pathnames['open-borrower-account'],
    // THIRD_PARTY_E_NOTARY: pathnames['open-borrower-account'],
    AWAITING_CREDIT_MANAGER_DECISION: pathnames['open-borrower-account'],
    DECISION_LAWYER: pathnames['open-borrower-account'],
    DECISION_COLLATERAL: pathnames['open-borrower-account'],
    OPEN_FL_CARD: pathnames['open-borrower-account'],
    OPEN_PLEDGER_FL_CARD: pathnames['open-borrower-account'],
    OPEN_UL_CARD: pathnames['open-borrower-account'],
    OPEN_BORROWER_ACCOUNT: pathnames['open-borrower-account'],

    PAYBOX_COMISSION_FEE_PAYMENT: pathnames['pledge-fee-payment'],
    SET_PAY_DAY: pathnames['documents-sign'],
    GET_CORP_CARD_DATA: pathnames['documents-sign'],
    DECISION_ESTIMATOR: pathnames['documents-sign'],
    GENERATE_CONCLUSION_ON_COLLATERAL: pathnames['documents-sign'],
    REGISTER_IN_COLVIR: pathnames['documents-sign'],
    COLVIR_MORTGAGE: pathnames['documents-sign'],
    GENERATE_MAIN_DOCUMENTS: pathnames['documents-sign'],
    GENERATE_DOCUMENTS_SIGNED_BY_ECP: pathnames['documents-sign'],
    CREATE_APPLICATION_IN_CRED_ADMIN: pathnames['documents-sign'],
    WAIT_FOR_CONFIRMATION_FROM_CRED_ADMIN: pathnames['documents-sign'],
    ACQUAINTANCE_WITH_DOCUMENTS: pathnames['documents-sign'],
    SIGN_BIOMETRY_FORENSICS: pathnames['certification-center'],
    SEND_OTP_SMS: pathnames['certification-center'],
    SIGN_DOCS_CERTIFICATION_CENTER: pathnames['internal-step-loader'],
    SEND_CERT_CENTER_SIGNATURES: pathnames['internal-step-loader'],
    THIRD_PARTY_PLEDGER_BIOMETRY_FORENSICS: pathnames['internal-step-loader'],
    SEND_THIRD_PARTY_PLEDGER_OTP_SMS: pathnames['internal-step-loader'],
    SIGN_DOCS_CERTIFICATION_CENTER_THIRD_PARTY_PLEDGER: pathnames['internal-step-loader'],
    ACQUAINTANCE_THIRD_PARTY_PLEDGER_WITH_DOCUMENTS: pathnames['internal-step-loader'],
    SIGN_BANK_LOAN_AGREEMENT_BY_BANK: pathnames['internal-step-loader'],
    SIGN_REPAYMENT_SCHEDULE_BY_BANK: pathnames['internal-step-loader'],
    SIGN_PLEDGE_AGREEMENT_BY_BANK: pathnames['internal-step-loader'],
    BLOCKCHAIN_CREATE_RECORD: pathnames['internal-step-loader'],
    LOAN_ACTUALIZE: pathnames['internal-step-loader']
  }

  return paths[key]
}
